import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'All',
  colors: [],
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    statusChanged: (state, action) => {
      state.status = action.payload;
    },
    colorChanged: (state, action) => {
      const { color, changeType } = action.payload;
      console.log(color);
      if (changeType === 'added') {
        state.colors.push(color);
      } else if (changeType === 'removed') {
        const filtersColor = state.colors.filter(
          (existingColor) => existingColor !== color
        );
        state.colors = filtersColor;
      }
    },
  },
});

export const { colorChanged, statusChanged } = filterSlice.actions;

export default filterSlice.reducer;
